var render = function render(){
  var _vm$selectedItem, _vm$$route$query, _vm$headerForm, _vm$$route$query3, _vm$headerForm2, _vm$$route$query4, _vm$$route$query5, _vm$$route$query6, _vm$$route$query7, _vm$$route$query8, _vm$$route$query9, _vm$headerForm3, _vm$$route$query0, _vm$headerForm4, _vm$$route$query1, _vm$$route$query20;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments);
      }
    }
  }, [_c('b-row', [_c('ModalAttacment', {
    attrs: {
      "isOpen": _vm.showModal,
      "attachments": (_vm$selectedItem = _vm.selectedItem) === null || _vm$selectedItem === void 0 ? void 0 : _vm$selectedItem.filePreview
    },
    on: {
      "close": function close($event) {
        _vm.showModal = false;
      }
    }
  }), _c('b-sidebar', {
    attrs: {
      "right": "",
      "width": "70%",
      "bg-variant": "white",
      "title": _vm.titleSidebar,
      "shadow": "",
      "backdrop": ""
    },
    on: {
      "hide": function hide($event) {
        _vm.selectedItem = null;
      }
    },
    model: {
      value: _vm.showSidebar,
      callback: function callback($$v) {
        _vm.showSidebar = $$v;
      },
      expression: "showSidebar"
    }
  }, [_vm.showSidebar ? [_vm.titleSidebar == 'Add Service & Repair' || _vm.titleSidebar == 'Update Service & Repair' ? _c('div', [_c('FormItemSR', {
    attrs: {
      "loading": _vm.loading.post,
      "multipleSelected": _vm.multipleSelected,
      "headerForm": _vm.headerForm,
      "optionsTaskType": _vm.optionsTaskType,
      "optionsDepartment": _vm.optionsDepartment,
      "optionsCategory": _vm.optionsCategory,
      "optionsClassification": _vm.optionsClassification,
      "optionsCause": _vm.optionsCause,
      "optionsKindTask": _vm.optionsKindTask,
      "selectedItem": _vm.selectedItem,
      "formId": _vm.formId,
      "fleetSelected": _vm.fleetSelected
    },
    on: {
      "onUpdateSr": _vm.handleUpdateJobs,
      "close": function close($event) {
        _vm.showSidebar = false;
      },
      "save": _vm.handleSaveItem,
      "refetch": _vm.handleRefetch
    }
  })], 1) : _vm._e(), _vm.titleSidebar == 'Progress Item Repair' || _vm.titleSidebar == 'Detail Item Service & Repair' ? _c('div', [_c('DailyProgress', {
    attrs: {
      "readonly": _vm.titleSidebar == 'Detail Item Service & Repair',
      "selectedItem": _vm.selectedItem,
      "optionsTaskType": _vm.optionsTaskType,
      "optionsDepartment": _vm.optionsDepartment,
      "optionsCategory": _vm.optionsCategory,
      "optionsClassification": _vm.optionsClassification,
      "optionsCause": _vm.optionsCause,
      "optionsKindTask": _vm.optionsKindTask,
      "formId": _vm.formId,
      "defaultParams": _vm.defaultParams
    },
    on: {
      "refetch": function refetch() {
        return _vm.getSingleServiceAndRepair(_vm.formId);
      }
    }
  })], 1) : _vm._e(), _vm.titleSidebar == 'Review Item Service & Repair' ? _c('div', [_c('FormReviewSR', {
    attrs: {
      "multipleSelected": _vm.multipleSelected,
      "selectedItem": _vm.selectedItem,
      "optionsTaskType": _vm.optionsTaskType,
      "optionsDepartment": _vm.optionsDepartment,
      "optionsCategory": _vm.optionsCategory,
      "optionsClassification": _vm.optionsClassification,
      "optionsCause": _vm.optionsCause,
      "optionsKindTask": _vm.optionsKindTask,
      "formId": _vm.formId
    },
    on: {
      "refetch": _vm.handleRefetch
    }
  })], 1) : _vm._e(), _vm.titleSidebar == 'Approve Item Service & Repair' ? _c('div', [_c('FormApproveSR', {
    attrs: {
      "multipleSelected": _vm.multipleSelected,
      "selectedItem": _vm.selectedItem,
      "optionsTaskType": _vm.optionsTaskType,
      "optionsDepartment": _vm.optionsDepartment,
      "optionsCategory": _vm.optionsCategory,
      "optionsClassification": _vm.optionsClassification,
      "optionsCause": _vm.optionsCause,
      "optionsKindTask": _vm.optionsKindTask,
      "formId": _vm.formId
    },
    on: {
      "refetch": _vm.handleRefetch
    }
  })], 1) : _vm._e()] : _vm._e()], 2), _c('b-col', {
    attrs: {
      "lg": "6"
    }
  }, [!((_vm$$route$query = _vm.$route.query) !== null && _vm$$route$query !== void 0 && _vm$$route$query.finish) ? _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('i', {
    staticClass: "fa fa-undo mr-4 cursor-pointer",
    on: {
      "click": function click($event) {
        return _vm.$router.push('/sr/service-repair-list');
      }
    }
  }), _c('i', {
    staticClass: "fa fa-refresh mr-4 cursor-pointer",
    on: {
      "click": _vm.handleRefetch
    }
  }), ((_vm$headerForm = _vm.headerForm) === null || _vm$headerForm === void 0 ? void 0 : _vm$headerForm.status) != 'finish' ? [_c('i', {
    staticClass: "fa fa-plus mr-4 cursor-pointer",
    on: {
      "click": _vm.onClickAdd
    }
  }), _vm.getPermissionSR('update') ? _c('i', {
    staticClass: "fa fa-edit mr-4 cursor-pointer",
    on: {
      "click": _vm.handleEditMulti
    }
  }) : _vm._e(), _vm.getPermissionSR('delete') ? _c('i', {
    staticClass: "fa fa-trash cursor-pointer",
    on: {
      "click": function click() {
        var _vm$$route$query2;
        return (_vm$$route$query2 = _vm.$route.query) !== null && _vm$$route$query2 !== void 0 && _vm$$route$query2.formId ? _vm.handleDeleteJobs() : _vm.deleteItemBeforeCreate();
      }
    }
  }) : _vm._e()] : _vm._e(), (_vm$$route$query3 = _vm.$route.query) !== null && _vm$$route$query3 !== void 0 && _vm$$route$query3.detail && ((_vm$headerForm2 = _vm.headerForm) === null || _vm$headerForm2 === void 0 ? void 0 : _vm$headerForm2.status) != 'finish' ? _c('div', {
    staticClass: "d-flex align-items-center ml-5"
  }, [_vm.showReview && _vm.getPermissionSR('review') ? _c('b-button', {
    staticClass: "px-3 mr-2",
    attrs: {
      "type": "button",
      "variant": "info",
      "size": "sm"
    },
    on: {
      "click": _vm.onReviewBulk
    }
  }, [_vm._v("Review")]) : _vm._e(), _vm.showApprove && _vm.getPermissionSR('approval') ? _c('b-button', {
    staticClass: "px-3",
    attrs: {
      "type": "button",
      "disabled": !_vm.listItems.some(function (el) {
        var _el$status;
        return (el === null || el === void 0 ? void 0 : (_el$status = el.status) === null || _el$status === void 0 ? void 0 : _el$status.name) == 'Review';
      }),
      "variant": "primary",
      "size": "sm"
    },
    on: {
      "click": _vm.onApproveBulk
    }
  }, [_vm._v("Approve")]) : _vm._e()], 1) : _vm._e()], 2) : _vm._e()]), _c('b-col', {
    staticClass: "d-flex justify-content-end",
    attrs: {
      "lg": "6"
    }
  }, [_c('form', {
    staticClass: "w-100 d-flex justify-content-end",
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
      }
    }
  }, [_c('b-form-input', {
    staticClass: "w-50 bg-white",
    attrs: {
      "placeholder": "Search..."
    },
    model: {
      value: _vm.filterByName,
      callback: function callback($$v) {
        _vm.filterByName = $$v;
      },
      expression: "filterByName"
    }
  })], 1)]), _c('b-col', {
    staticClass: "mt-3",
    attrs: {
      "lg": "12"
    }
  }, [_c('div', {
    staticClass: "overflow-auto relative w-100"
  }, [_c('table', {
    staticClass: "w-100"
  }, [_c('thead', [!((_vm$$route$query4 = _vm.$route.query) !== null && _vm$$route$query4 !== void 0 && _vm$$route$query4.finish) ? _c('th', {
    staticClass: "sticky col-1"
  }, [_c('input', {
    staticStyle: {
      "width": "16px",
      "height": "16px"
    },
    attrs: {
      "type": "checkbox",
      "id": "checkal",
      "name": "checkal",
      "disabled": _vm.headerForm.status == 'finish'
    },
    domProps: {
      "checked": _vm.isChckedAll
    },
    on: {
      "change": function change(e) {
        _vm.checkedAll = e.target.checked;
        _vm.handleCheckAll();
      }
    }
  })]) : _vm._e(), _c('th', {
    staticClass: "sticky",
    class: {
      'col-2': !((_vm$$route$query5 = _vm.$route.query) !== null && _vm$$route$query5 !== void 0 && _vm$$route$query5.finish),
      'col-2-finish': (_vm$$route$query6 = _vm.$route.query) === null || _vm$$route$query6 === void 0 ? void 0 : _vm$$route$query6.finish
    }
  }, [_vm._v(" Action ")]), _c('th', {
    staticClass: "text-nowrap sticky",
    class: {
      'col-3': !((_vm$$route$query7 = _vm.$route.query) !== null && _vm$$route$query7 !== void 0 && _vm$$route$query7.finish),
      'col-3-finish': (_vm$$route$query8 = _vm.$route.query) === null || _vm$$route$query8 === void 0 ? void 0 : _vm$$route$query8.finish
    }
  }, [_vm._v(" Equipment Name ")]), _c('th', {
    staticClass: "text-nowrap"
  }, [_vm._v("Attachment")]), _c('th', {
    staticClass: "text-nowrap"
  }, [_vm._v("Est. Cost Per Task")]), (_vm$$route$query9 = _vm.$route.query) !== null && _vm$$route$query9 !== void 0 && _vm$$route$query9.finish || (_vm$headerForm3 = _vm.headerForm) !== null && _vm$headerForm3 !== void 0 && _vm$headerForm3.cost_real ? _c('th', {
    staticClass: "text-nowrap"
  }, [_vm._v("Real Cost Per Item *")]) : _vm._e(), (_vm$$route$query0 = _vm.$route.query) !== null && _vm$$route$query0 !== void 0 && _vm$$route$query0.finish || (_vm$headerForm4 = _vm.headerForm) !== null && _vm$headerForm4 !== void 0 && _vm$headerForm4.cost_real ? _c('th', {
    staticClass: "text-nowrap"
  }, [_vm._v("Done By")]) : _vm._e(), (_vm$$route$query1 = _vm.$route.query) !== null && _vm$$route$query1 !== void 0 && _vm$$route$query1.detail || _vm.formId ? _c('th', {
    staticClass: "text-nowrap"
  }, [_vm._v("Status Item")]) : _vm._e(), _c('th', {
    staticClass: "text-nowrap"
  }, [_vm._v("Work Item")]), _c('th', {
    staticClass: "text-nowrap"
  }, [_vm._v("Est. Start Date")]), _c('th', {
    staticClass: "text-nowrap"
  }, [_vm._v("Est. Finish Date")]), _c('th', {
    staticClass: "text-nowrap"
  }, [_vm._v("Type Repair")]), _c('th', {
    staticClass: "text-nowrap"
  }, [_vm._v("Repair Section")]), _c('th', {
    staticClass: "text-nowrap"
  }, [_vm._v("Category")]), _c('th', {
    staticClass: "text-nowrap"
  }, [_vm._v("Classification")]), _c('th', {
    staticClass: "text-nowrap"
  }, [_vm._v("Cause")]), _c('th', {
    staticClass: "text-nowrap"
  }, [_vm._v("Kind Of Task")]), _c('th', {
    staticClass: "text-nowrap"
  }, [_vm._v("Item Remarks")])]), _c('tbody', [!_vm.loading.fetch ? _vm._l(_vm.listItems, function (item, index) {
    var _vm$$route$query10, _item$status, _vm$$route$query11, _vm$$route$query12, _item$status2, _item$status3, _item$status4, _item$status5, _item$status6, _vm$$route$query13, _vm$$route$query14, _item$file, _vm$formatCurrency, _vm$$route$query15, _vm$headerForm5, _vm$headerForm6, _vm$$route$query16, _vm$formatCurrency2, _vm$$route$query17, _vm$headerForm7, _vm$headerForm8, _vm$$route$query18, _vm$doneByOptions$fin, _vm$doneByOptions, _vm$doneByOptions$fin2, _vm$$route$query19, _item$status7, _item$status8, _item$status9, _item$status0, _item$status1;
    return _c('tr', {
      key: index,
      staticClass: "bg-white"
    }, [_vm.isVisible(item) ? [!((_vm$$route$query10 = _vm.$route.query) !== null && _vm$$route$query10 !== void 0 && _vm$$route$query10.finish) ? _c('td', {
      staticClass: "sticky col-1 bg-white"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: item.checked,
        expression: "item.checked"
      }],
      staticClass: "pr-0",
      staticStyle: {
        "width": "16px",
        "height": "16px"
      },
      attrs: {
        "type": "checkbox",
        "disabled": ['Progress', 'Finish'].includes(item === null || item === void 0 ? void 0 : (_item$status = item.status) === null || _item$status === void 0 ? void 0 : _item$status.name)
      },
      domProps: {
        "checked": Array.isArray(item.checked) ? _vm._i(item.checked, null) > -1 : item.checked
      },
      on: {
        "change": function change($event) {
          var $$a = item.checked,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && _vm.$set(item, "checked", $$a.concat([$$v]));
            } else {
              $$i > -1 && _vm.$set(item, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            _vm.$set(item, "checked", $$c);
          }
        }
      }
    })]) : _vm._e(), _c('td', {
      staticClass: "sticky bg-white",
      class: {
        'col-2': !((_vm$$route$query11 = _vm.$route.query) !== null && _vm$$route$query11 !== void 0 && _vm$$route$query11.finish),
        'col-2-finish': (_vm$$route$query12 = _vm.$route.query) === null || _vm$$route$query12 === void 0 ? void 0 : _vm$$route$query12.finish
      }
    }, [_c('b-button', {
      staticClass: "d-flex align-items-center",
      attrs: {
        "type": "button",
        "id": "popover-target-".concat(index),
        "variant": "outline-primary",
        "size": "sm"
      }
    }, [_vm._v("Action "), _c('i', {
      staticClass: "fa fa-caret-down ml-2"
    })]), _c('b-popover', {
      attrs: {
        "target": "popover-target-".concat(index),
        "triggers": "focus",
        "placement": "bottom",
        "custom-class": "p-0"
      }
    }, [(item === null || item === void 0 ? void 0 : (_item$status2 = item.status) === null || _item$status2 === void 0 ? void 0 : _item$status2.name) === 'Review' && _vm.getPermissionSR('approval') ? _c('div', {
      staticClass: "p-1 px-3 action-item cursor-pointer",
      on: {
        "click": function click() {
          return _vm.onClickApprove(item);
        }
      }
    }, [_vm._v("Approve Item")]) : _vm._e(), (item === null || item === void 0 ? void 0 : (_item$status3 = item.status) === null || _item$status3 === void 0 ? void 0 : _item$status3.name) === 'New' && _vm.getPermissionSR('review') ? _c('div', {
      staticClass: "p-1 px-3 action-item cursor-pointer",
      on: {
        "click": function click() {
          return _vm.onClickReview(item);
        }
      }
    }, [_vm._v("Review Item")]) : _vm._e(), _c('div', {
      staticClass: "p-1 px-3 action-item cursor-pointer",
      on: {
        "click": function click() {
          return _vm.onClickDetail(item);
        }
      }
    }, [_vm._v("Detail Item")]), !['Progress', 'Finish'].includes(item === null || item === void 0 ? void 0 : (_item$status4 = item.status) === null || _item$status4 === void 0 ? void 0 : _item$status4.name) && _vm.getPermissionSR('update') ? _c('div', {
      staticClass: "p-1 px-3 action-item cursor-pointer",
      on: {
        "click": function click() {
          return _vm.onEditItem(item, index);
        }
      }
    }, [_vm._v("Update Item")]) : _vm._e(), !['Progress', 'Finish'].includes(item === null || item === void 0 ? void 0 : (_item$status5 = item.status) === null || _item$status5 === void 0 ? void 0 : _item$status5.name) && _vm.getPermissionSR('delete') ? _c('div', {
      staticClass: "p-1 px-3 action-item cursor-pointer",
      on: {
        "click": function click() {
          return _vm.onDeleteItem(item, index);
        }
      }
    }, [_vm._v("Delete Item")]) : _vm._e(), (item === null || item === void 0 ? void 0 : (_item$status6 = item.status) === null || _item$status6 === void 0 ? void 0 : _item$status6.name) === 'Progress' ? _c('div', {
      staticClass: "p-1 px-3 action-item cursor-pointer",
      on: {
        "click": function click($event) {
          return _vm.onClickActivity(item);
        }
      }
    }, [_vm._v("Progress Activity")]) : _vm._e()])], 1), _c('td', {
      staticClass: "sticky bg-white",
      class: {
        'col-3': !((_vm$$route$query13 = _vm.$route.query) !== null && _vm$$route$query13 !== void 0 && _vm$$route$query13.finish),
        'col-3-finish': (_vm$$route$query14 = _vm.$route.query) === null || _vm$$route$query14 === void 0 ? void 0 : _vm$$route$query14.finish
      }
    }, [_vm._v(" " + _vm._s(item.name == 'Others' ? item.other_name : item.name) + " ")]), _c('td', {
      staticClass: "p-2"
    }, [_c('b-button', {
      staticClass: "d-flex justify-content-between align-items-center text-nowrap",
      attrs: {
        "type": "button",
        "variant": "warning",
        "size": "sm"
      },
      on: {
        "click": function click($event) {
          ;
          _vm.showModal = true, _vm.selectedItem = item;
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-paperclip"
    }), _vm._v(_vm._s((_item$file = item.file) === null || _item$file === void 0 ? void 0 : _item$file.length) + " Attachment")])], 1), _c('td', {
      staticClass: "text-nowrap"
    }, [_vm._v(" " + _vm._s((_vm$formatCurrency = _vm.formatCurrency(item.cost_estimate)) !== null && _vm$formatCurrency !== void 0 ? _vm$formatCurrency : '-') + " ")]), (_vm$$route$query15 = _vm.$route.query) !== null && _vm$$route$query15 !== void 0 && _vm$$route$query15.finish || (_vm$headerForm5 = _vm.headerForm) !== null && _vm$headerForm5 !== void 0 && _vm$headerForm5.cost_real ? _c('td', {
      style: {
        minWidth: '240px'
      }
    }, [(_vm$headerForm6 = _vm.headerForm) !== null && _vm$headerForm6 !== void 0 && _vm$headerForm6.cost_real && (_vm$$route$query16 = _vm.$route.query) !== null && _vm$$route$query16 !== void 0 && _vm$$route$query16.detail ? [_vm._v(" " + _vm._s((_vm$formatCurrency2 = _vm.formatCurrency(item.cost_real)) !== null && _vm$formatCurrency2 !== void 0 ? _vm$formatCurrency2 : '-') + " ")] : _c('div', [_c('InputCurrency', {
      on: {
        "input": _vm.sumRealCost
      },
      model: {
        value: item.cost_real,
        callback: function callback($$v) {
          _vm.$set(item, "cost_real", $$v);
        },
        expression: "item.cost_real"
      }
    })], 1)], 2) : _vm._e(), (_vm$$route$query17 = _vm.$route.query) !== null && _vm$$route$query17 !== void 0 && _vm$$route$query17.finish || (_vm$headerForm7 = _vm.headerForm) !== null && _vm$headerForm7 !== void 0 && _vm$headerForm7.cost_real ? _c('td', {
      staticClass: "p-2",
      staticStyle: {
        "min-width": "200px"
      }
    }, [(_vm$headerForm8 = _vm.headerForm) !== null && _vm$headerForm8 !== void 0 && _vm$headerForm8.cost_real && (_vm$$route$query18 = _vm.$route.query) !== null && _vm$$route$query18 !== void 0 && _vm$$route$query18.detail ? _c('div', {
      staticClass: "px-3"
    }, [_vm._v(" " + _vm._s((_vm$doneByOptions$fin = (_vm$doneByOptions = _vm.doneByOptions) === null || _vm$doneByOptions === void 0 ? void 0 : (_vm$doneByOptions$fin2 = _vm$doneByOptions.find(function (el) {
      return el.value == (item === null || item === void 0 ? void 0 : item.done_by);
    })) === null || _vm$doneByOptions$fin2 === void 0 ? void 0 : _vm$doneByOptions$fin2.text) !== null && _vm$doneByOptions$fin !== void 0 ? _vm$doneByOptions$fin : '-') + " ")]) : _c('b-form-select', {
      attrs: {
        "options": _vm.doneByOptions,
        "plain": "",
        "required": ""
      },
      model: {
        value: item.done_by,
        callback: function callback($$v) {
          _vm.$set(item, "done_by", $$v);
        },
        expression: "item.done_by"
      }
    })], 1) : _vm._e(), (_vm$$route$query19 = _vm.$route.query) !== null && _vm$$route$query19 !== void 0 && _vm$$route$query19.detail || _vm.formId ? _c('td', {
      staticClass: "text-nowrap"
    }, [_c('b-badge', {
      attrs: {
        "variant": "".concat((item === null || item === void 0 ? void 0 : (_item$status7 = item.status) === null || _item$status7 === void 0 ? void 0 : _item$status7.name) === 'New' ? 'info' : (item === null || item === void 0 ? void 0 : (_item$status8 = item.status) === null || _item$status8 === void 0 ? void 0 : _item$status8.name) === 'Review' ? 'primary' : (item === null || item === void 0 ? void 0 : (_item$status9 = item.status) === null || _item$status9 === void 0 ? void 0 : _item$status9.name) === 'Reject' ? 'danger' : (item === null || item === void 0 ? void 0 : (_item$status0 = item.status) === null || _item$status0 === void 0 ? void 0 : _item$status0.name) === 'Finish' ? 'danger' : 'success', " d-block")
      }
    }, [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : (_item$status1 = item.status) === null || _item$status1 === void 0 ? void 0 : _item$status1.name))])], 1) : _vm._e(), _c('td', {
      staticClass: "text-nowrap"
    }, [_vm._v(_vm._s(item.title) + " ")]), _c('td', {
      staticClass: "text-nowrap"
    }, [_vm._v(" " + _vm._s(_vm.moment(item.start_at).format('DD MMM YYYY')) + " ")]), _c('td', {
      staticClass: "text-nowrap"
    }, [_vm._v(" " + _vm._s(_vm.moment(item.estimated_finished_at).format('DD MMM YYYY')) + " ")]), _c('td', {
      staticClass: "text-nowrap"
    }, [_vm._v(" " + _vm._s(_vm.findText(_vm.optionsTaskType, item.task_type_id)) + " ")]), _c('td', {
      staticClass: "text-nowrap"
    }, [_vm._v(" " + _vm._s(item.section) + " ")]), _c('td', {
      staticClass: "text-nowrap"
    }, [_vm._v(" " + _vm._s(_vm.findText(_vm.optionsCategory, item.category_id)) + " ")]), _c('td', {
      staticClass: "text-nowrap"
    }, [_vm._v(" " + _vm._s(_vm.findText(_vm.optionsClassification, item.classification_id)) + " ")]), _c('td', {
      staticClass: "text-nowrap"
    }, [_vm._v(" " + _vm._s(_vm.findText(_vm.optionsCause, item.case_id)) + " ")]), _c('td', {
      staticClass: "text-nowrap"
    }, [_vm._v(" " + _vm._s(_vm.findText(_vm.optionsKindTask, item.kind_task_id)) + " ")]), _c('td', {
      staticClass: "pr-4",
      staticStyle: {
        "max-width": "400px",
        "white-space": "nowrap",
        "overflow": "hidden"
      }
    }, [_c('p', {
      staticClass: "m-0 ellipsis",
      attrs: {
        "id": "tooltip-remark-".concat(item.id)
      }
    }, [_vm._v(" " + _vm._s(item.description) + " ")]), _c('b-tooltip', {
      staticClass: "custom-style-tooltip",
      attrs: {
        "target": "tooltip-remark-".concat(item.id),
        "triggers": "hover",
        "placement": "top"
      }
    }, [_vm._v(" " + _vm._s(item.description))])], 1)] : _vm._e()], 2);
  }) : _vm._e()], 2)]), _vm.loading.fetch ? _c('div', {
    staticClass: "d-flex justify-content-center py-5"
  }, [_c('b-spinner', {
    attrs: {
      "size": "lg"
    }
  })], 1) : _vm._e()])]), (_vm$$route$query20 = _vm.$route.query) !== null && _vm$$route$query20 !== void 0 && _vm$$route$query20.detail && _vm.formId ? _c('b-col', {
    staticClass: "mt-4",
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.log-collapse",
      modifiers: {
        "log-collapse": true
      }
    }],
    attrs: {
      "type": "button",
      "variant": "link"
    }
  }, [_c('h6', [_c('strong', [_vm._v("Log History")])])]), _c('b-collapse', {
    attrs: {
      "id": "log-collapse"
    }
  }, [_c('LogsHistoryItemSR', {
    attrs: {
      "defaultParams": _vm.defaultParams,
      "selectedItem": {
        id: _vm.formId
      }
    }
  })], 1)], 1) : _vm._e(), !_vm.$route.query.detail ? [_c('b-col', {
    staticClass: "d-flex justify-content-end mt-4"
  }, [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "type": "button",
      "variant": "outline-primary"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push('/sr/service-repair-list');
      }
    }
  }, [_vm._v("Cancel")]), !_vm.loading.post ? _c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_vm._v("Submit")]) : _c('b-button', {
    attrs: {
      "type": "button",
      "variant": "primary"
    }
  }, [_c('b-spinner', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }), _vm._v(" Loading... ")], 1)], 1)] : _vm._e(), !_vm.$route.query.detail && _vm.formId && !_vm.$route.query.finish ? [_c('b-col', {
    staticClass: "d-flex justify-content-end mt-4"
  }, [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "type": "button",
      "variant": "outline-primary"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push('/sr/service-repair-list');
      }
    }
  }, [_vm._v("Cancel")]), _vm.getPermissionSR('update') ? [!_vm.loading.post ? _c('b-button', {
    attrs: {
      "type": "button",
      "variant": "primary"
    },
    on: {
      "click": function click() {
        return _vm.handleUpdateJobs(_vm.listItems);
      }
    }
  }, [_vm._v("Submit")]) : _c('b-button', {
    attrs: {
      "type": "button",
      "variant": "primary"
    }
  }, [_c('b-spinner', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }), _vm._v(" Loading... ")], 1)] : _vm._e()], 2)] : _vm._e()], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }